import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleHeading6 extends ToolToggleBlock {
  static toolName = 'Heading 6';
  static iconClass = 'fa-regular fa-h6';
  static blockType = 'h6';
}

export default ToolToggleHeading6;
